import { render, staticRenderFns } from "./ReceiptForm.vue?vue&type=template&id=774a9622&scoped=true&"
import script from "./ReceiptForm.vue?vue&type=script&lang=ts&"
export * from "./ReceiptForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptForm.vue?vue&type=style&index=0&id=774a9622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774a9622",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCol,VForm,VRow,VTextField})
